import { Money } from '@dreryk/money-common-api';

import { createVisitor } from '~libs.typescript';

type AdvancePaymentStatusData = {
   paidAmount: Money;
   requiredAmount: Money;
};

export const advancePaymentStatusVisitor = createVisitor<
   AdvancePaymentStatusData,
   {
      visitPaid: void;
      visitUnderpayment: void;
      visitOverpayment: void;
   }
>((data, visitor) => {
   const paid = data.paidAmount.asNumber();
   const required = data.requiredAmount.asNumber();

   if (paid === required) {
      return visitor.visitPaid?.();
   }

   if (paid < required) {
      return visitor.visitUnderpayment?.();
   }

   return visitor.visitOverpayment?.();
});
